/* Wallet Guard: pause layout scripts while wallet is active */
(() => {
  let timer;
  const add = () => {
    document.body.classList.add('wallet-open', 'overflow-hidden'); // pauses equalizer & any scroll locks
    clearTimeout(timer);
    // safety: auto-clear after 2 minutes in case of aborted sessions
    timer = setTimeout(remove, 120000);
  };
  const remove = () => {
    document.body.classList.remove('wallet-open', 'overflow-hidden');
    clearTimeout(timer);
  };

  // Any click on a Shopify wallet button = wallet likely presenting
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.shopify-payment-button__button, .shopify-payment-button [role="button"]');
    if (btn) add();
  }, true);

  // If page regains focus / becomes visible again, consider wallet finished
  window.addEventListener('pageshow', remove, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') remove();
  });
})();
